import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { drw, errText } from "./api";
import { AssignStep } from "./FinishWizard";

/** TKO-2 §4 — the FRS's Unassigned bucket per scope, with Assign opening the same assignment
 *  step the Finish wizard uses. Units here are live app marks with no room; nothing else counts
 *  them (R4). Renders nothing when there is nothing unassigned. */
export default function UnassignedBucket({ projectId, onChanged }) {
  const [data, setData] = useState(null);
  const [assign, setAssign] = useState(null);
  const load = () => drw.get(`/projects/${projectId}/takeoff/unassigned`).then(({ data: d }) => setData(d)).catch(() => setData(null));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [projectId]);
  const open = async () => {
    try { const { data: a } = await drw.get(`/projects/${projectId}/takeoff/unassigned/assignment`); setAssign(a); }
    catch (e) { toast.error(errText(e)); }
  };
  if (!data || !data.total) return null;
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-3 mb-2" data-testid="frs-unassigned-bucket" data-total={data.total}>
      <div className="flex items-center gap-3 flex-wrap text-sm">
        <span className="font-semibold text-amber-900">Unassigned — {data.total} unit{data.total === 1 ? "" : "s"} added on the plan with no room yet</span>
        {data.scopes.map((s) => (
          <span key={s.scope_code} className="px-2 py-0.5 rounded bg-white border text-xs" data-testid={`unassigned-scope-${s.scope_code}`}>
            <b>{s.scope_code}</b> {s.units} · {s.products.map((p) => `${p.product_code} ×${p.units}`).join(", ")}{s.sheets.length ? ` · ${s.sheets.join(", ")}` : ""}
          </span>
        ))}
        <button type="button" onClick={open} className="ml-auto h-8 px-3 rounded-md bg-neutral-900 text-white text-xs font-semibold" data-testid="unassigned-assign">Assign</button>
      </div>
      <div className="text-[11px] text-amber-800 mt-1">Picking, delivery and install ignore these until they have a room.</div>
      {assign && (
        <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-3" data-testid="unassigned-assign-dialog">
          <div className="bg-white rounded-xl w-full max-w-3xl max-h-[88vh] overflow-auto p-4">
            <AssignStep projectId={projectId} data={assign} onDone={() => { setAssign(null); load(); onChanged?.(); }} onCancel={() => setAssign(null)} />
          </div>
        </div>
      )}
    </div>
  );
}
